/**
 * Activate an existing customer in Klaviyo with language
 * @author Lina Arroyo <lina.arroyo@gradiweb.com>
 */

import { registerEmailInKlaviyo } from '../services/klaviyo';
import { $Q } from "../utils/query-selector";
const axios = require("axios");

const createCustomerWithLang = (email, lang) => {
    registerEmailInKlaviyo(email, lang);
}
let customerID = document.querySelector('.activate__form input[type="hidden"][name="id"]'); 

async function fetchResponse(id) {
    if (id) {
        let customer = await axios.get(`https://centrale-fillers-app.herokuapp.com/get_customer?id=${id}`);
        let customerEmail = customer.data.response.body.customer.email;
        return customerEmail;
    }
}

async function getCustomerData(id, lang) {
    if (typeof id == "string" || typeof id == "number") {
        let customerEmail = await fetchResponse(id);
        let customerLang = lang.options[lang.selectedIndex].value;
        if (typeof customerLang == "string") {
            createCustomerWithLang(customerEmail, customerLang);
        }
    }
}

let registerButton = $Q("#activate-customerBtn");

if (registerButton) {
    registerButton.addEventListener('click', async () => {
        let langSelector = $Q("#dropdown-selector-activate-account");
        await getCustomerData(customerID.value, langSelector);
    });
}
